import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/flickr': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM144.5 319C109.4 319 81 290.6 81 255.5S109.4 192 144.5 192 208 220.4 208 255.5 179.6 319 144.5 319zM303.5 319C268.4 319 240 290.6 240 255.5S268.4 192 303.5 192 367 220.4 367 255.5 338.6 319 303.5 319z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/flickr.js
// module id = yGPT
// module chunks = 144